import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=0c14bb30&scoped=true&"
import script from "./BookingCard.vue?vue&type=script&lang=js&"
export * from "./BookingCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=0c14bb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14bb30",
  null
  
)

export default component.exports